export enum Environment {
  Localhost = 'localhost-gms-api',
  Develop = 'develop-gms-api',
  RC = 'rc-gms-api',
  Staging = 'staging-gms-api',
  Production = 'production-gms-api'
}
